import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SiteAsset {
  id: string;
  role: string;
  label: string | null;
  caption: string | null;
  file_url: string;
  thumbnail_url: string | null;
  display_order: number;
  active: boolean;
  metadata: Record<string, unknown> & { key?: string };
  created_at: string;
}

export function useSiteAssets(role: string) {
  return useQuery({
    queryKey: ["site_assets", role],
    queryFn: async (): Promise<SiteAsset[]> => {
      const { data, error } = await supabase
        .from("site_assets")
        .select("*")
        .eq("role", role)
        .eq("active", true)
        .order("display_order", { ascending: true })
        .order("created_at", { ascending: true });
      if (error) throw error;
      return (data || []) as SiteAsset[];
    },
    staleTime: 60_000,
  });
}

export function useSiteAssetSingle(role: string) {
  const q = useSiteAssets(role);
  return { ...q, asset: q.data?.[0] ?? null };
}
